export const HANDOVER_STATUS = {
  RECEIVED: "RECEIVED",
  ACCEPTED: "ACCEPTED",
  INITIAL: "INITIAL",
  REQUESTED: "REQUESTED",
  CANCELLED: "CANCELLED",
  RESCHEDULED: "RESCHEDULED",
};

export const HANDOVER_DIALOGUES = {
  RELEASE_COMMS: "handOverReleaseComms",
  RELEASE_COMMS_CALENDER: "handOverReleaseCommsCalender",
  APPOINTMENT: "handOverAppointment",
  CANCEL_APPOINTMENT: "handOverCancelAppointment",
  COMPLETE: "handOverComplete",
  COMPLETE_CONFIRM: "handOverCompleteConfirm",
  COMPLETE_CALENDER: "handOverCompleteCalender",
};

export const HANDOVER_TYPES = {
  COLLECTION: "collection",
  DELIVERY: "delivery",
};
